import React from 'react';
import Pagination10 from './Pagination10';

// Adapter component: recebe `setPagination` do hook usePagination10
// e repassa as props esperadas por Pagination10.
function PaginationBar({ setPagination }) {
  if (!setPagination) return null;
  const {
    totalItems,
    rowsPerPage,
    startIndex,
    onRowsPerPageChange,
    onFirstItems,
    onPreviousItems,
    onNextItems,
    onLastItems,
  } = setPagination;

  return (
    <div style={{ padding: '0.5rem 0rem', borderTop: '1px solid rgba(0,0,0,0.1)', backgroundColor: '#f8f9fa' }}>
    <Pagination10
      totalItems={totalItems}
      rowsPerPage={rowsPerPage}
      startIndex={startIndex}
      onRowsPerPageChange={onRowsPerPageChange}
      onFirstItems={onFirstItems}
      onPreviousItems={onPreviousItems}
      onNextItems={onNextItems}
      onLastItems={onLastItems}
    />
  </div>
  );
}

export default PaginationBar;
